<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="false"
    width="90vw"
    top="5vh"
    custom-class="img-lightbox-dialog"
    @close="$emit('close')"
  >
    <div class="lb-body" @click.self="$emit('close')">
      <template v-if="current">
        <img class="lb-img" :src="current" alt="图片预览">
        <button type="button" class="lb-close" aria-label="关闭" @click="$emit('close')">
          <i class="el-icon-close" />
        </button>
        <template v-if="list.length > 1">
          <button type="button" class="lb-nav prev" aria-label="上一张" @click.stop="prev">
            <i class="el-icon-arrow-left" />
          </button>
          <button type="button" class="lb-nav next" aria-label="下一张" @click.stop="next">
            <i class="el-icon-arrow-right" />
          </button>
          <div class="lb-count">{{ index + 1 }} / {{ list.length }}</div>
        </template>
      </template>
      <p v-else class="lb-empty">暂无图片</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImageLightbox',
  props: {
    show: { type: Boolean, default: false },
    /** 正文里所有图片地址，用于左右切换 */
    list: { type: Array, default: () => [] },
    /** 打开时展示第几张 */
    startIndex: { type: Number, default: 0 }
  },
  data() {
    return { index: 0 }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(v) { if (!v) this.$emit('close') }
    },
    current() {
      return this.list[this.index] || ''
    }
  },
  watch: {
    show(v) {
      if (v) this.index = this.clamp(this.startIndex)
    }
  },
  mounted() {
    // 方向键翻页，ESC 关闭由 el-dialog 自带
    document.addEventListener('keydown', this.onKey)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey)
  },
  methods: {
    clamp(i) {
      const n = this.list.length
      if (!n) return 0
      return Math.min(Math.max(i, 0), n - 1)
    },
    prev() {
      const n = this.list.length
      if (n > 1) this.index = (this.index - 1 + n) % n
    },
    next() {
      const n = this.list.length
      if (n > 1) this.index = (this.index + 1) % n
    },
    onKey(e) {
      if (!this.show) return
      if (e.key === 'ArrowLeft') this.prev()
      else if (e.key === 'ArrowRight') this.next()
    }
  }
}
</script>

<style lang="scss" scoped>
.lb-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

.lb-img {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.lb-empty {
  color: #fff;
  font-size: 14px;
  padding: 24px 0;
}

.lb-close,
.lb-nav {
  position: absolute;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(15, 41, 66, 0.55);
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover {
    background: rgba(15, 41, 66, 0.8);
    transform: scale(1.05);
  }
}

.lb-close {
  top: 8px;
  right: 8px;
  font-size: 18px;
}

.lb-nav {
  top: 50%;
  margin-top: -18px;

  &.prev { left: 8px; }
  &.next { right: 8px; }
}

.lb-count {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  padding: 3px 12px;
  border-radius: 12px;
  background: rgba(15, 41, 66, 0.55);
  color: #fff;
  font-size: 12px;
  letter-spacing: 0.02em;
}
</style>

<style lang="scss">
/* 图片查看器：去掉对话框默认外观，只留遮罩 + 图片
   html.theme-jiu .el-dialog 的优先级更高，暗夜模式下要强制透明 */
.img-lightbox-dialog {
  max-width: 94vw;
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;

  .el-dialog__header { display: none; }

  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}
</style>
